<template>
  <div class="tv-player">
    <object
      id="av-player"
      class="tv-player__video"
      type="application/avplayer"
      v-if="getIsTizen"
    ></object>
    <object
      id="av-player"
      class="tv-player__video"
      v-if="getIsLG && getLGVersion >= '5.0'"
    ></object>
    <video
      id="av-player"
      class="tv-player__video"
      v-if="getLGVersion < '5.0'"
    ></video>
    <object
      id="av-player"
      class="tv-player__video"
      type="application/avplayer"
      v-if="getIsOrsay"
    ></object>
    <video
      v-if="!getIsOrsay && !getIsLG && !getIsTizen"
      class="tv-player__video"
      src="https://media.digmedia.net/website/video/rain_264.mp4?_=1"
      muted
      autoplay
      loop
    ></video>
    <transition name="fade">
      <div class="tv-osd" v-if="showOSD">
        <!-- <div class="tv-osd" v-if="true"> -->
        <!-- <div id="subtitle" class="subtitle"></div> -->
        <div class="tv-osd__header">
          <div class="tv-osd__header-back">
            <div class="tv-osd__header-app">
              <Icon2
                class="tv-osd__app-icon"
                color="#c1c1c1"
                icon-name="WayfinderTv"
                :height="96"
                :width="96"
                ><WayfinderTv />
              </Icon2>
            </div>
            <Icon
              class="tv-osd__back-icon"
              icon-name="WayfinderArrowLeft"
              color="#f1f1f1"
              :height="46"
              :width="46"
              :class="{ 'tv-osd__back-icon--active': isBackButtonActive }"
              ><WayfinderArrowLeft />
            </Icon>
            {{ getBack }}
          </div>
          <div class="tv-osd__header-title">
            {{ $store.getters['tv/getChannelHeadline'] }}
          </div>
        </div>
        <div class="tv-osd__body">
          <ul class="tv-osd__channel-list" ref="listWrapper">
            <li
              v-for="(channel, index) in getChannels"
              :key="'chanel-' + index"
              class="channel-list__channel truncate"
              :class="{
                'channel-list__channel--active':
                  $store.getters['tv/getTargetChannelIndex'] === index &&
                  !isBackButtonActive,
              }"
              :style="getStyleSheetOffset"
              ref="listElements"
            >
              <div class="channel-list__channel-logo-wrapper">
                <template v-if="channel.epgChannelId > 0">
                  <img loading="lazy" v-if="$store.getters['tv/getEpgById'](channel.epgChannelId)"
                    class="channel-list__channel-logo"
                    :src="getEpgLogo($store.getters['tv/getEpgById'](channel.epgChannelId))"
                    alt=""
                  />
                </template>
              </div>
              {{ index + 1 }}. {{ channel.name }}
            </li>
          </ul>
          <div class="tv-osd__channel-info"></div>
        </div>
      </div>
    </transition>
    <transition name="fade" v-if="!isBackButtonActive">
      <div class="epg-osd" v-if="showOSD && $store.getters['tv/getChannelLength'] > 0">
        <div class="epg-osd__header">
          {{ $store.getters['tv/getTargetChannelIndex'] + 1 }}. {{ getChannels[$store.getters['tv/getTargetChannelIndex']].name }}
        </div>
        <div class="epg-osd__body">
          <ul class="epg-osd__channelepg-list" ref="listEPGWrapper">
            <li
              v-for="(epg, index) in getChannelsEPG"
              :key="'chanelepg-' + index"
              class="channelepg-list__channelepg truncate"
              ref="listEPGElements"
            >
              <div class="epg-osd__channelepg-list-data">
                <span class="epg-osd__channelepg-list-date">{{ epg.start }}&nbsp;-&nbsp;{{ epg.end }}</span>
                <span class="epg-osd__channelepg-list-name">{{ epg.name }}</span><br>
                <span class="epg-osd__channelepg-list-text">{{ epg.text }}</span>
              </div>
            </li>
          </ul>

        </div>
      </div>
    </transition>
    <div v-if="osdVisible" class="osd-overlay">
      <div class="osd-content">
        {{ getChannelName }}: {{ osdChannel }}
      </div>
    </div>
  </div>
</template>

<script>
import DeviceType from '@/helpers/DeviceType';
import { keyHandler, KEYS } from '@/mixins/keyHandler';
import router from '@/router';
import TV, { TV_STATUS } from '@/helpers/TV';
import Icon from '@/components/Icon.vue';
import Icon2 from '@/components/Icon2.vue';
import WayfinderArrowLeft from '@/assets/icons/WayfinderArrowLeft.vue';
import WayfinderTv from '@/assets/icons/WayfinderTv.vue';
import { NAV_TYPE } from '@/store/modules/navigation';

var pressedKey = 0;
var timer = 0;
var maxChannelIndex = 0;

export default {
  components: { Icon, Icon2, WayfinderArrowLeft, WayfinderTv },
  mixins: [keyHandler],
  props: {
    origin: String,
  },
  data() {
    return {
      error: {
        active: false,
        message: '',
      },
      connectedVideoSources: [],
      availableWindows: [],
      isWindowVisible: false,
      currentWindowSource: null,
      tvPlayer: null,
      tvPlayerState: null,
      ipAddress: null,
      tvStatus: '',
      showOSD: true,
      fadeOutTimer: 0,
      osdInterval: null,
      isBackButtonActive: false,
      activeElement: 0,
      scrollPositionCounter: 0,
      visibleElements: 9,
      wrapperHeight: 0,
      elementHeight: 100,
      scrollCounterOffset: 3,
      osdVisible: false,
      osdTimer: null,
      osdChannel: '',
    };
  },
  watch: {
    fadeOutTimer(value) {
      if (value >= 4000) {
        this.showOSD = false;
        clearInterval(this.osdInterval);
      }
    },
    showOSD(isTrue) {
      if (isTrue) {
        this.handleOSDFadeInOut();
      }
    },
  },
  methods: {
    handleKeyDown(e) {
      console.log('KEYDOWN EVENT: ', e);
    },
    async init() {
      try {
        this.$store.dispatch('tv/init', {origin: this.origin} );
        this.handleOSDFadeInOut();
      } catch (err) {
        console.log(err);
        this.error.active = true;
        this.error.message = 'could not fetch channels';
      }
    },
    getEPGData(channelTarget) {
      //channelId => channel_id, language, country, name

      //channelId, this.$store.state.epgGuide
      //tvChannelData[1..15] -> epgChannelId, name => INDEX
      //programsByPages[0..14][0][0] -> start, startISO, end, endISO, name, text
      //programs[0..14][0] -> start, startISO, end, endISO, description, title
      var epgGuideData = '';
      if(this.$store.getters["tv/getChannels"].length && channelTarget.serviceType === 'tv') {
        epgGuideData = Object.entries(this.$store.state.epgGuide);
        const dateNow = Date.now();
        const epgChannelIndex = epgGuideData[3][1].findIndex((el) => el.name === channelTarget.name);
        if(epgChannelIndex >= 0 && epgGuideData[4][1][epgChannelIndex]) {
          const channelPool = Object.entries(epgGuideData[4][1][epgChannelIndex]);
          const epgDataIndex = channelPool.findIndex(el => { if(el[1].startISO <= dateNow && el[1].endISO > dateNow) return el[1]; });
          if(epgDataIndex >= 0) {
            var epgData = new Array();
            epgData.push(channelPool[epgDataIndex][1]);
            epgData.push(channelPool[epgDataIndex + 1][1]);
            return epgData;
          } else {
            return [];
          }
        } else {
          return [];
        }
      } else {
        return '';
      }
    },
    resetIntervallTimer() {
      this.fadeOutTimer = 0;
    },
    increaseFadeOutTimer() {
      this.fadeOutTimer += 1000;
    },
    handleOSDFadeInOut() {
      this.osdInterval = setInterval(this.increaseFadeOutTimer, 1000);
    },
    showQuickselectOSD(channel) {
      this.osdChannel = channel;
      this.osdVisible = true;
      clearTimeout(this.osdTimer);
      this.osdTimer = setTimeout(() => {
        this.hideQuickselectOSD();
      }, 5000);
    },
    hideQuickselectOSD() {
      this.osdVisible = false;
      this.osdChannel = '';
      clearTimeout(this.osdTimer);
    },
    eventHandler(key, event) {
      this.showOSD = true;
      this.resetIntervallTimer();
      switch (key) {
        case KEYS.ENTER:
          this.hideQuickselectOSD();
          if (this.isBackButtonActive) {
            this.$store.dispatch('navigation/to', NAV_TYPE.BACK);
            break;
          }
          // this.toggleWindow();
          //console.log("===================getTargetChannelIndex", this.$store.getters['tv/getTargetChannelIndex']);
          this.$store.dispatch(
            'tv/setTargetChannel',
            this.$store.getters['tv/getTargetChannelIndex']
          );
          break;
        case KEYS.CHANNEL_DOWN:
          this.$store.dispatch('tv/setChannelPrev');
          break;
        case KEYS.CHANNEL_UP:
          this.$store.dispatch('tv/setChannelNext');
          break;
        case KEYS.INFO:
          //this.$store.dispatch('tv/showOSD');
          break;
        case KEYS.KEY_0:
        case KEYS.KEY_1:
        case KEYS.KEY_2:
        case KEYS.KEY_3:
        case KEYS.KEY_4:
        case KEYS.KEY_5:
        case KEYS.KEY_6:
        case KEYS.KEY_7:
        case KEYS.KEY_8:
        case KEYS.KEY_9:
          //if(location.hash === '#/' || location.hash === '#/tv-player' || location.hash === '#/tv-player?origin=epg') {
            maxChannelIndex = this.$store.getters['tv/getChannelLength'] - 1;
            if(parseInt(pressedKey) > 0) {
              pressedKey = pressedKey + key;
              if(timer) {
                clearTimeout(timer);
                timer = 0;
              }
            }else if(parseInt(pressedKey) > 9) {
              pressedKey = pressedKey + key;
              if(timer) {
                clearTimeout(timer);
                timer = 0;
              }
            } else {
              pressedKey = key;
            }
            this.showQuickselectOSD(pressedKey);
            /*if (timer) {
              clearTimeout(timer);
            }*/
            timer = setTimeout(() => {
              let startChannel = {
                "index": parseInt(pressedKey) - 1,
              }
              pressedKey = 0;
              if(startChannel.index <= maxChannelIndex && startChannel.index >= 0) {
                this.$store.commit('tv/setChannelIndex', startChannel.index , { root: true });
                this.$store.commit('tv/setTargetIndex', startChannel.index , { root: true });
                this.$store.commit('tv/setChannel', startChannel.index , { root: true });
              }
              this.hideQuickselectOSD();
            }, 1250);
          //}

          //if (this.getTVStatus === TV_STATUS.LOADED) {
            //console.log("==================KEY", this.getTVStatus);
            //this.$store.dispatch('tv/showOSD');
            //this.$store.dispatch('tv/setShowOSD');
            //this.handleOSDFadeInOut();
            //this.showOSD = true;
          //}
          break;
        case KEYS.BACK:
          console.log("=============================this.getTVStatus", this.getTVStatus);
          if (this.getTVStatus === TV_STATUS.LOADED || this.getTVStatus === TV_STATUS.CLOSED) {
            this.$store.dispatch('navigation/to', NAV_TYPE.BACK);
          }
          break;
        case KEYS.UP:
          let firstChannel = this.$store.getters['tv/getIsFirstChannel'];
          if (firstChannel && !this.isBackButtonActive) {
            this.isBackButtonActive = true;
          } else if (firstChannel && this.isBackButtonActive) {
            this.isBackButtonActive = false;
            this.$store.dispatch('tv/setTargetPrev');
          } else if (this.isBackButtonActive) {
            this.isBackButtonActive = false;
          } else {
            this.$store.dispatch('tv/setTargetPrev');
          }
          break;
        case KEYS.DOWN:
          let lastChannel = this.$store.getters['tv/getIsLastChannel'];
          if (lastChannel && !this.isBackButtonActive) {
            this.isBackButtonActive = true;
          } else if (lastChannel && this.isBackButtonActive) {
            this.isBackButtonActive = false;
            this.$store.dispatch('tv/setTargetNext');
          } else if (this.isBackButtonActive) {
            this.isBackButtonActive = false;
          } else {
            this.$store.dispatch('tv/setTargetNext');
          }
          break;
      }
    },
    stopTVChannel() {
      try {
        this.$store.dispatch('tv/kill');
      } catch (e) {
        console.log('error on close');
        // this.$store.dispatch('notification/new', {
        //   title: 'Error while stop tv',
        //   message: JSON.stringify(e),
        // });
      }
    },
    callbackTizen(context) {
      this.$store.dispatch('notification/new', {
        title: 'CALLBACK TIZEN',
        message: JSON.stringify(context),
      });
      //console.log("CALLBACK TIZEN");
    },
    callbackLG(context) {
      this.$store.dispatch('notification/new', {
        title: 'CALLBACK LG',
        message: JSON.stringify(context),
      });
      //console.log("CALLBACK LG");
    },
    callbackOrsay(context) {
      this.$store.dispatch('notification/new', {
        title: 'CALLBACK ORSAY',
        message: JSON.stringify(context),
      });
      //console.log("CALLBACK ORSAY");
    },
    callbackFindWindows(context) {
      this.$store.dispatch('notification/new', {
        title: 'CALLBACK TIZEN',
        message: JSON.stringify(context),
      });
      this.availableWindows = context;
    },
    callbackTizenVideoSources(videoSource) {
      this.connectedVideoSources = videoSource.connected;
    },
    callbackLGVideoSources(videoSource) {
      this.connectedVideoSources = videoSource.connected;
    },
    callbackOrsayVideoSources(videoSource) {
      this.connectedVideoSources = videoSource.connected;
    },
    getEpgLogo(logourl) {
      if(typeof logourl != 'undefined' && typeof logourl.logo_url != 'undefined') {
        //console.log("====================LOGOURL", logourl);
        let logoUrlArray = (logourl.logo_url).split("/");
        let imagepath = 'https://media.digmedia.net/epgimg/'+ logoUrlArray[logoUrlArray.length - 1] + '.png';
        //console.log("====================IMAGEPATH", imagepath);
        return imagepath;
      } else {
        return 'https://media.digmedia.net/epgimg/0.png';
      }
    },
  },
  beforeDestroy() {
    this.$store.dispatch('tv/kill');
  },

  mounted() {
    // if (this.$refs.listElements)
    //   this.elementHeight = this.$refs.listElements[0].offsetHeight;

    if (this.$refs.listWrapper)
      this.wrapperHeight = this.$refs.listWrapper.offsetHeight;

    //if (this.$refs.listEPGWrapper)
    //  this.wrapperHeight = this.$refs.listEPGWrapper.offsetHeight;

    if (this.$refs.listElements && this.$refs.listWrapper) {
      const calcedItems = Math.floor(this.wrapperHeight / this.elementHeight);
      this.visibleElements = calcedItems < 10 ? calcedItems : 9;
    } else {
      this.visibleElements = 9;
    }
    if (this.visibleElements - this.scrollCounterOffset <= 0) {
      this.scrollCounterOffset = 1;
    } else if (
      this.visibleElements - this.scrollCounterOffset <
      this.scrollCounterOffset
    ) {
      this.scrollCounterOffset =
        this.scrollCounterOffset -
        (this.visibleElements - this.scrollCounterOffset);
    }

    this.init();
  },
  computed: {
    getBack() {
      return this.$i18n('back.name');
    },
    getActiveSubMenuElementIndex: {
      get() {
        return this.$store.getters['navigation/getActiveSubMenuElementIndex'];
      },
    },
    getActiveSubMenu: {
      get() {
        return this.$store.getters['navigation/getActiveSubMenu'];
      },
    },
    getBackground() {
      return this.$store.getters['navigation/getActiveSubMenuBackground'];
    },
    getActiveSubMenuItems: {
      get() {
        return this.getActiveSubMenu.items;
      },
    },
    getActiveItem() {
      return this.$store.getters['navigation/getActiveSubMenuItem'];
    },
    getActiveItemType: {
      get() {
        return this.getActiveItem.type;
      },
    },
    getActiveItemActionUrl: {
      get() {
        return this.getActiveItem.actionUrl;
      },
    },
    getPreviewSource: {
      get() {
        return this.getActiveItem.thumbnail;
      },
    },
    getDescription: {
      get() {
        return this.getActiveItem.description;
      },
    },
    getScrollPosition: {
      get() {
        return this.getScrollPositionCounter * this.elementHeight;
      },
    },
    getStyleSheetOffset: {
      get() {
        return { transform: `translateY(-${this.getScrollPosition}px)` };
      },
    },
    getSubMenuStyle: {
      get() {
        const styles = {
          color: this.textColor,
        };
        console.log(this.getBackground);
        if (this.getBackground)
          styles.backgroundImage = `url(${this.getBackground})`;
        if (this.backgroundColor) styles.backgroundColor = this.backgroundColor;
        else styles.backgroundColor = 'black';
        return styles;
      },
    },
    getScrollPositionCounter() {
      const initialOffset = this.visibleElements - this.scrollCounterOffset;
      if (
        this.getTargetChannelIndex <
        this.visibleElements - this.scrollCounterOffset
      ) {
        return 0;
      }
      if (
        this.getTargetChannelIndex >
        this.getChannelListLength - 1 - this.scrollCounterOffset
      ) {
        return this.getChannelListLength - 1 - this.visibleElements;

        // return (
        //   this.getChannelListLength - initialOffset - this.scrollCounterOffset
        // );
      }
      return this.getTargetChannelIndex - initialOffset;
    },
    getTargetChannelIndex() {
      return this.$store.getters['tv/getTargetChannelIndex'];
    },
    getChannelListLength() {
      return this.$store.getters['tv/getChannelLength'];
    },
    getChannels() {
      return this.$store.getters['tv/getChannels'];
    },
    getChannelsEPG() {
      //return this.getEPGData(this.$store.getters['tv/getEpgById'](this.$store.getters['tv/getActiveChannel'].epgChannelId));
      return this.getEPGData(this.getChannels[this.$store.getters['tv/getTargetChannelIndex']]);
    },
    getIsTizen() {
      return DeviceType.isTizen;
    },
    getLGVersion() {
      return window.lgVersion;
    },
    getIsLG() {
      return DeviceType.isLG;
    },
    getIsOrsay() {
      return DeviceType.isOrsay;
    },
    /*
    getCurrentSourceIndex: {
      get() {
        return this.connectedVideoSources.findIndex(
          (el) =>
            el.type === this.currentWindowSource.type &&
            el.number === this.currentWindowSource.number
        );
      },
    },
    */
    getTVStatus() {
      return this.$store.getters['tv/getStatus'];
    },
    getChannelName() {
      return this.$i18n('channel.name');
    },
  },
};
</script>

<style scoped>
.tv-player {
  /* width: 50%; */
  height: 100vh;
  position: relative;
  width: 100vw;
  z-index: 100;
}

h2 {
  font-weight: bold;
  margin: 0.5rem 0;
}
.properties {
  padding-left: 1rem;
}

.tv-player__content {
  display: flex;
}

.tv-player__video {
  background: transparent;
  height: 100vh;
  top: 0;
  position: absolute;
  left: 0;
  width: 100vw;
  z-index: 200;
}
.subtitle {
  background: red;
  color: black;
  min-height: 5vh;
  bottom: 5%;
  position: absolute;
  width: 50vw;
  z-index: 205;
}

.tv-osd {
  color: #f1f1f1;
  left: 0;
  height: 100vh;
  position: absolute;
  top: 0;
  width: 100vw;
  z-index: 210;
}

.tv-osd__header {
  align-items: flex-end;
  border-bottom: 2px solid #f1f1f1;
  display: flex;
  font-size: 6.0vh;
  height: 9.5vh;
  width: 100%;
}

.tv-osd__header-back {
  align-items: center;
  display: flex;
  flex: 0 0 30%;
  padding-left: 1.5rem;
  text-align: left;
}
.tv-osd__header-app {
  display: flex;
  flex-direction: column;
  border-right: 2px solid #f1f1f1;
  padding-right: 1.3rem;
  margin-right: 0.5rem;
}
.tv-osd__header-title {
  padding-left: 1rem;
}

.tv-osd__body {
  align-items: stretch;
  display: flex;
  justify-content: stretch;
  height: calc(100vh - 80px);
}
.tv-osd__channel-list {
  flex: 0 0 30%;
  text-align: left;
  overflow: hidden;
  max-height: calc(100vh - 80px);
  width: 30%;
}

.epg-osd {
  color: #f1f1f1;
  border-left: 2px solid #f1f1f1;
  border-top: 2px solid #f1f1f1;
  border-right: 2px solid #f1f1f1;
  left: 53.5vh;
  right: 0.5vw;
  height: 25vh;
  position: absolute;
  bottom: 0;
  width: 69.8%;
  z-index: 220;
}

.epg-osd__channelepg-list {
  /*flex: 0 0 100%;*/
  /*text-align: left;*/
  overflow: hidden;
  max-height: calc(100vh - 80px);
}

.epg-osd__channelepg-list-data {
  
}

.epg-osd__channelepg-list-date {
  color: #dbd2d2;
  font-weight: 700;
  padding-right: 1%;
}

.epg-osd__channelepg-list-name {
  color: #dbd2d2;
  font-weight: 700;
  position: absolute;
  left: 11vw;
  margin-right: 0.5vw;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.epg-osd__channelepg-list-text {
  color: #a1a1a1;
  font-weight: 500;
  margin-left: 10vw;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.epg-osd__header {
  align-items: flex-end;
  border-bottom: 2px solid #f1f1f1;
  display: flex;
  font-size: 6vh;
  height: 9vh;
  width: 100%;
  padding-left: 1rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.epg-osd__header-title {
  padding-left: 1rem;
}

.epg-osd__body {
  background: rgba(0, 0, 0, 0.7);
  /*align-items: stretch;*/
  /*display:flex;*/
  /*justify-content: stretch;*/
  height: 20vh;
  /*width: calc(100% - 10vw);*/
  right: 1vw;
  padding-left: 1rem;
}
.epg-osd__epg-list {
  flex: 0 0 20%;
  text-align: left;
  overflow: hidden;
  /*max-height: calc(100vh - 80px);*/
  height: 20%;
}

.channelepg-list__channelepg {
  border-bottom: 1px white;
  display: flex;
  padding: 0.25rem;
  margin: 0.1rem 0 -0.1rem 0.2rem;
  font-size: 2.5vh;
  /*height: 2vh;*/
  width: 95%;
  /*transition: transform 0.3s ease-in-out;*/
}

.channel-list__channel {
  border: 2px solid transparent;
  border-right: none;
  display: flex;
  padding: 1rem;
  margin: 0.25rem 0 0.25rem 0.25rem;
  font-size: 2.75vh;
  height: 8.5vh;
  transition: transform 0.3s ease-in-out;
}
.channel-list__channel--active {
  border-color: #f1f1f1;
}

.channel-list__channel-logo-wrapper {
  align-items: center;
  background: #f1f1f1;
  border-radius: 5px;
  display: flex;
  height: 6vh;
  justify-content: center;
  margin-right: 1vw;
  padding: 5px;
  width: 4vw;
  min-width: 4vw;
}

.channel-list__channel-logo {
  object-fit: contain;
  height: 100%;
  width: 100%;
  /*background-color: burlywood;*/
}
/* .channel-list__channel-icon {
}
.channel-list__channel-name {
} */

.tv-osd__header,
.tv-osd__channel-list {
  background: rgba(0, 0, 0, 0.7);
}

.tv-osd__header-back,
.tv-osd__channel-list {
  border-right: 2px solid #f1f1f1;
}

.fade-enter-active {
  transition: all 0.1s ease-in-out;
}
.fade-leave-active {
  transition: all 0.3s ease-in-out;
}
.fade-leave-to,
.fade-enter {
  opacity: 0;
}
.fade-leave,
.fade-enter-to {
  opacity: 1;
}

.tv-osd__back-icon {
  border: 2px solid transparent;
  padding: 0.5rem;
  margin-right: 1rem;
}
.tv-osd__back-icon--active {
  border-color: #f1f1f1;
}

.tv-osd__app-icon {
  /*padding: 0.5rem;
  padding-top: 1rem;*/
}

.epg-osd__header,
.epg-osd__channel-list {
  background: rgba(0, 0, 0, 0.7);
}

.osd-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(131, 38, 38, 0.7);
  padding: 20px;
  border-radius: 10px;
  z-index: 1000;
}

.osd-content {
  color: white;
  font-size: 24px;
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/pages/TVPlayer.vue